<div class="top" [style.background-image]="trustedImage">
  <img [src]="logo" alt="GoArmy Edge Logo" class="edge-logo">

  <div class="social" *ngIf="socialIcons">
    <a angulartics2On="click"
       angularticsCategory="Outbound Clicks"
       angularticsEvent="Social"
       [angularticsProperties]="{ label: icon.sport + ' ' + icon.alt }"
       [href]="icon.link"
       target="_blank"
       *ngFor="let icon of socialIcons">
      <img [src]="icon.image" alt="{{ icon.alt }}" class="{{ icon.alt }}">
    </a>
  </div>
</div>

<div class="tagline">
  <h2 [innerHTML]="tagline"></h2>
</div>

<div class="hero-bottom">
  <ng-content></ng-content>
</div>
